import { Navigate } from 'react-router-dom';

import LoginForm from '../forms/login';
import { ROUTES } from '../../../core/constants/routes';
import { useAuth } from '../../../global/contexts/auth/auth';

import '../styles/standalone.css';

export default function LoginScreen() {
    const { isAuthenticated } = useAuth();
    if (isAuthenticated) return <Navigate to={ROUTES.HOME} replace />;
    return (
        <main className="standalone">
            <div className="standalone__panel">
                <span className="standalone__mark" aria-hidden="true">M</span>
                <h1 className="standalone__title">Entrar a Mastermind</h1>
                <LoginForm />
            </div>
        </main>
    );
}
